import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ImageService } from 'src/app/Core/services/image.service';
import { ConfirmationDialogComponent } from '../../confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ToasterService } from 'src/app/Core/services/toaster.service';
import { Location } from '@angular/common';
export interface ImageDetails {
  uuid: string;
  button_text: string;
  description: string;
  end_date: Date;
  image_type: string;
  image_url: string;
  language: string;
  read_more_link: string;
  start_date: Date;
  title: string;
  rank_key: string;
  status?: string; 
  created_time: Date;
  updated_time: Date;
  created_by: string;
  updated_by:string;
  content_type: string;
  image_size: string;
  image_dimension: string;
}

@Component({
  selector: 'app-image-details',
  templateUrl: './image-details.component.html',
  styleUrls: ['./image-details.component.css']
})
export class ImageDetailsComponent implements OnInit {
  selectedImage: ImageDetails | null = null;
  dateFormat: string = 'dd MMM yyyy h:mm:ss a zzzz';

  constructor(
    private router: Router,
    private imageService: ImageService,
    private dialog: MatDialog,
    private toaster: ToasterService,
    private location: Location,
  ) {}

  ngOnInit(): void {
    this.selectedImage = history.state.selectedImage as ImageDetails;
  }

  updateImage() {
    if (this.selectedImage) {
      this.router.navigate(['/update-image'], { state: { selectedImage: this.selectedImage } });
    }
  }

  deleteImage() {
    if (this.selectedImage) {
      const imageId = this.selectedImage.uuid;
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        data: { confirmationText: 'Are you sure you want to delete this image?' }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result === 'yes') {
          this.imageService.deleteImage(imageId).subscribe(
            () => {
              this.toaster.openDialogBox('Image deleted successfully',true);
            },
            error => {
              console.error('Failed to delete image', error);
              if(error.status === 403){
              this.toaster.openDialogBox("You don't have the required permission",false)
              }
            }
          );
        }
      });
    }
  }

  navigateToUpload() {
    // this.router.navigate(['/upload']);
    this.location.back();
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'Active':
        return 'status-active';
      case 'Expired':
        return 'status-expired';
      case 'Scheduled':
        return 'status-scheduled';
      default:
        return '';
    }
  }
}
